import script from "./TabIntegracao.vue?vue&type=script&setup=true&lang=js"
export * from "./TabIntegracao.vue?vue&type=script&setup=true&lang=js"

import "./TabIntegracao.vue?vue&type=style&index=0&id=531e4ae1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-531e4ae1"]])

export default __exports__